import { render } from "./BlockedActivityFeedListed.vue?vue&type=template&id=5ecc39a5&scoped=true"
import script from "./BlockedActivityFeedListed.vue?vue&type=script&lang=js"
export * from "./BlockedActivityFeedListed.vue?vue&type=script&lang=js"

import "./BlockedActivityFeedListed.vue?vue&type=style&index=0&id=5ecc39a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecc39a5"]])

export default __exports__